import React, { useContext, useEffect } from "react";
import "../styles/styles.css";
import "../../../styles/global.css";
import AccreditationButton from "../../AccreditationButton/AccreditationButton";
import { icons } from "../../../constants";
import { TranslationsContext } from "../../../utils/TranslationsContext";

const ConfirmationModal = ({
  handleConfirmClick,
  handleDeclineClick,
  count,
  status,
  term,
  notification,
  warning,
  question,
  checkboxLabel,
  checkboxChecked,
  onCheckboxChange,
}) => {
  const { t, isLoading } = useContext(TranslationsContext);

  useEffect(() => {
    // Handle Enter key to trigger confirm action
    const handleEnterKey = (event) => {
      if (event.key === "Enter" && !event.shiftKey && !event.ctrlKey && !event.metaKey) {
        // Don't trigger if user is typing in a textarea or input
        const target = event.target;
        if (target.tagName === "TEXTAREA" || (target.tagName === "INPUT" && target.type !== "submit")) {
          return;
        }
        event.preventDefault();
        handleConfirmClick();
      }
    };

    // Handle Escape key to close modal
    const handleEscapeKey = (event) => {
      if (event.key === "Escape") {
        handleDeclineClick();
      }
    };

    document.addEventListener("keydown", handleEnterKey);
    document.addEventListener("keydown", handleEscapeKey);

    return () => {
      document.removeEventListener("keydown", handleEnterKey);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [handleConfirmClick, handleDeclineClick]);

  console.log("sssasaatus", status);

  const handleOverlayClick = (e) => {
    // Only close if clicking directly on the overlay, not on modal content
    if (e.target === e.currentTarget) {
      handleDeclineClick();
    }
  };

  return (
    <div 
      className="flex-direction-column items-center justify-center confirmation-modal-wrapper"
      onClick={handleOverlayClick}
    >
      <div
        className={`flex-direction-column gap-48 confirmation-modal ${
          notification ? "has-notification" : ""
        }`}
        style={{
          borderTop: `10px solid ${
            status === "odobren" 
              ? "var(--Green-box)" 
              : status === "odbijen" || term
              ? "var(--Red-box)"
              : "var(--Red-box)"
          }`,
        }}
      >
        <div
          className="flex-direction-column gap-4 inria-sans-400 font-24"
          style={{ color: "var(--text-black)" }}
        >
          {count && status ? (
            <div className="flex-direction-row ">
              <p className="" style={{ color: "var(--text-black)" }}>
                <span
                  style={{
                    color:
                      status === "odobren" ? "var(--Green-2)" : "var(--Red-1)",
                  }}
                >
                  {status === "odobren" ? t("APPROVE") : t("REJECT")}
                </span>{" "}
                <span className="inria-sans-700 ">{count}</span> {t("PERSONS")}
              </p>
            </div>
          ) : (
            <p className="inria-sans-700 width-100">
              {question || t("ARE_YOU_SURE_YOU_WANT_TO_DELETE")}
              {term ? (
                <>
                  {" "}
                  <span style={{ color: "var(--Red-1)" }}>{term}</span>?
                </>
              ) : (
                "?"
              )}
            </p>
          )}
        </div>
        <div className="flex-direction-column gap-12">
          <div className="flex-direction-row gap-12">
            <AccreditationButton
              title={t("CONFIRM")}
              icon={status == "odbijen" ? icons.decline : icons.accept}
              type={status === "odbijen" ? "decline" : "accept"}
              onClick={handleConfirmClick}
              className={"confirmation-modal-accept-btn"}
            />
            <AccreditationButton
              title={t("DECLINE")}
              icon={icons.decline}
              type="close"
              onClick={handleDeclineClick}
              className={"confirmation-modal-decline-btn"}
            />
          </div>
          {notification && (
            <p
              className={`flex-direction-row items-center gap-8 inria-sans-400 font-14 notification ${
                warning ? "notification-warning" : ""
              }`}
            >
              {warning && (
                <img src={icons.warning} alt="warning" width={16} height={16} />
              )}
              {notification}
            </p>
          )}
          {checkboxLabel && (
            <label className="flex-direction-row items-center gap-8 inria-sans-400 font-14 pointer confirmation-modal-checkbox">
              <input
                type="checkbox"
                checked={!!checkboxChecked}
                onChange={(e) => onCheckboxChange?.(e.target.checked)}
              />
              {checkboxLabel}
            </label>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
